let pusherChannel = ''
let pusherAppKey = ''
pusherChannel = 'ecom-nuxt-v1'
pusherAppKey = '40bc5e09280d0951bc8b'

export { pusherChannel, pusherAppKey }
